module.exports = __webpack_public_path__ + "static/media/M003-icon.47bb3a4c.svg";